import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import i18n from "i18next";
import { auth } from "./auth/config";
import { resolveSupportedLanguage } from "./localization/supported-language";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) console.error(`[Network error]: ${networkError}`);
});

const fitnextHttpLink = createHttpLink({
  uri: `${import.meta.env.VITE_FITNEXT_ENDPOINT}/v1/graphql/user`,
});

const fitnextv2HttpLink = createHttpLink({
  uri: `${import.meta.env.VITE_FITNEXT_ENDPOINT}/v2/graphql/user`,
});

const splitLink = split(
  ({ getContext }) => getContext().endpoint === "fitnextv2",
  fitnextv2HttpLink,
  fitnextHttpLink
);

export const createClientAuthHeaders = async (
  headers: Record<string, string>,
) => {
  const authToken = await auth.currentUser?.getIdToken();
  const language = resolveSupportedLanguage(
    i18n.resolvedLanguage ?? i18n.language,
  );

  return {
    ...headers,
    ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    "x-hasura-role": "user",
    "Accept-Language": language,
    "x-graphql-client-name": "www-app",
    "x-graphql-client-version": APP_VERSION,
  };
};

const clientAuthLink = () =>
  setContext(async (_, { headers }) => ({
    headers: await createClientAuthHeaders(headers),
  }));

export const apolloClient = new ApolloClient({
  link: clientAuthLink().concat(from([errorLink, splitLink])),
  cache: new InMemoryCache(),
});
